import axios from "axios";
import { SERVER_URL } from "../../../config/env";
import authHeader from "../../../2_ksbHub/utils/auth/auth-header";

class SondertagService {
  async getSchoolyears() {
    const res = await axios.get(SERVER_URL + "sondertageapp/schoolyears", {
      headers: authHeader(),
    });
    return res.data;
  }

  async getSonderEvents(schoolyearId) {
    const res = await axios.get(
      SERVER_URL + `sondertageapp/getsonderevents/${schoolyearId}`,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async getStatsData(schoolyearId) {
    const res = await axios.get(
      SERVER_URL + `sondertageapp/stats/${schoolyearId}`,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  }

  // ✅ EVENT
  async createSonderEvent(data) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/sonderevent/create",
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async getSonderEventData(eventId) {
    const res = await axios.get(SERVER_URL + `sondertageapp/${eventId}`, {
      headers: authHeader(),
    });
    return res.data;
  }

  async createSonderEventFromTemplate(data) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/templateevent",
      data,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  }

  async updateSonderEvent(id, data) {
    const res = await axios.put(
      SERVER_URL + "sondertageapp/sondereventupdate/" + id,
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async deleteSonderEvent(id) {
    const res = await axios.delete(
      SERVER_URL + "sondertageapp/sonderevent/" + id,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  // ✅ GET all data
  async getSondertageData(eventId) {
    const res = await axios.get(SERVER_URL + `sondertageapp/${eventId}`, {
      headers: authHeader(),
    });
    console.log(res.data);

    return res.data;
  }

  // ✅ SONDERTAG
  async createSondertag(data) {
    console.log("DATA sent: ", data);
    const res = await axios.post(
      SERVER_URL + "sondertageapp/sondertag/create",
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async deleteSondertag(id) {
    const res = await axios.delete(
      SERVER_URL + "sondertageapp/sondertag/" + id,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async updateSondertag(id, data) {
    const res = await axios.put(
      SERVER_URL + "sondertageapp/sondertag/" + id,
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async getShift(id) {
    const res = await axios.get(SERVER_URL + `sondertageapp/sondertag/${id}`, {
      headers: authHeader(),
    });
    return res.data;
  }

  // ✅ LOCK / UNLOCK SCHOOLYEAR
  async updateLock(eventId, data) {
    const res = await axios.put(
      SERVER_URL + "sondertageapp/sonderevent/" + eventId + "/lock",
      data,
      {
        headers: authHeader(),
      },
    );
    // console.log(res.data);
    return res.data;
  }

  // ✅ JOB

  async getJob(id) {
    const res = await axios.get(SERVER_URL + `sondertageapp/job/${id}`, {
      headers: authHeader(),
    });
    return res.data;
  }

  async createJahrgang(data) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/jahrgang/create",
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async updateJahrgang(id, data) {
    const res = await axios.put(
      SERVER_URL + "sondertageapp/jahrgang/" + id,
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async deleteJahrgang(id) {
    const res = await axios.delete(
      SERVER_URL + "sondertageapp/jahrgang/" + id,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async createAngebot(data) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/angebot/create",
      data,
      { headers: authHeader() },
    );

    return res.data;
  }

  async updateAngebot(id, data) {
    const res = await axios.put(
      SERVER_URL + "sondertageapp/angebot/" + id,
      data,
      { headers: authHeader() },
    );

    return res.data;
  }

  async deleteAngebot(id) {
    const res = await axios.delete(SERVER_URL + "sondertageapp/angebot/" + id, {
      headers: authHeader(),
    });

    return res.data;
  }

  async lockAngebot(angebotId, userId, lockUserAbbreviation) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/angebot/lock",
      { angebotId, userId, lockUserAbbreviation },
      { headers: authHeader() },
    );

    return res.data;
  }

  async unlockAngebot(angebotId) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/angebot/unlock",
      { angebotId },
      { headers: authHeader() },
    );

    return res.data;
  }

  // ✅ RESERVATION
  async reserveAngebot(angebotId, userId, isAdmin) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/angebot/reserve",
      { angebotId, userId, isAdmin },
      { headers: authHeader() },
    );

    return res.data;
  }

  async createSondertagFromTemplate(data) {
    const res = await axios.post(SERVER_URL + "/templateday", data, {
      headers: authHeader(),
    });

    return res.data;
  }

  async getSondertagTemplates() {
    const res = await axios.get(
      SERVER_URL + "sondertageapp/sondertagtemplates",
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }
  async getSonderEventTemplates() {
    const res = await axios.get(
      SERVER_URL + "sondertageapp/sondereventtemplates",
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  /**
   * =========================================================
   * TEACHER STATS
   * =========================================================
   */

  async getTeacherStats(schoolyearId) {
    const res = await axios.get(
      SERVER_URL + `sondertageapp/teacherstats/${schoolyearId}`,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  }

  async createTeacherStat(data) {
    const res = await axios.post(
      SERVER_URL + "sondertageapp/teacherstats",
      data,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  }

  async updateTeacherStat(abbreviation, data) {
    const res = await axios.put(
      SERVER_URL + `sondertageapp/teacherstats/${abbreviation}`,
      data,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  }

  async deleteTeacherStat(abbreviation, schoolyearId) {
    const res = await axios.delete(
      SERVER_URL + `sondertageapp/teacherstats/${abbreviation}`,
      {
        headers: authHeader(),
        data: {
          schoolyearId,
        },
      },
    );

    return res.data;
  }

  async getTeacherWorkloads(schoolyearId) {
    const rows = await this.getTeacherStats(schoolyearId);

    const workloads = {};

    rows.forEach((row) => {
      workloads[row.abbreviation.toLowerCase()] = {
        name: row.teacher_name,
        workload: Number(row.workload),
      };
    });

    return workloads;
  }
}

const sondertagService = new SondertagService();
export default sondertagService;
